export default __webpack_public_path__ + "static/media/rr_coins.204998c0.svg";